import React from "react";
// import "./BillingInvoiceUploadFile.css";
import "../../GlobalCss/SPF/BillingInvoiceUploadFile.css"
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import BCSection from "../../Components/BillingCrawling/BCSection";
import { Button, Layout, Modal, Select, Spin, Tooltip } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { UploadOutlined } from "@ant-design/icons";
import { dwnldBillingAutocrawl, downloadBillingAutoCrawledFiles } from "../../Repository/BillingRepository";
import { InfoMessage } from "../../Utils/Utils";
import BillingInvoiceUploadFileTable from "../../Components/BillingInvoiceUploadFileTable/BillingInvoiceUploadFileTable";
const { Header, Content } = Layout;

const BillingInvoiceUploadFile = () => {
    return (<>
        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <Header className="preview-header-class"><Navbar /></Header>
                <Content style={{ overflow: 'auto', height: "100%" }}>
                    <div className="billing-header-class">
                        <span className="billing-header">InvoiceUploadFile</span>
                    </div>
                    <div>
                        <BillingInvoiceUploadFileTable/>
                    </div>
                </Content>
            </Layout>
        </Layout>
    </>)
}
export default BillingInvoiceUploadFile;